<template>
    <div id="app">
        <div v-if="hasAccess == true && (!$store.getters.isImpersonation || isSilentLoginOnceCalled)" id="nav">
            <router-view />
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    import service from './services/api.services'
    export default {
        name: "app",
        components: {

        },
        data() {
            return {
                isSilentLoginOnceCalled: false
            };
        },
        computed: {
            ...mapGetters("oidcStore", [
                "oidcIsAuthenticated"
            ]),
            hasAccess: function () {
                return this.oidcIsAuthenticated || this.$route.meta.isPublic;
            },
            apiCallCount: function () {
                return this.$store.getters.apiCallCount;
            }
        },
        watch: {
            apiCallCount() {
                if (this.$store.getters.isFirstLoadCompleted) {
                    this.authenticateOidcSilent()
                }
            }
        },
        methods: {
            ...mapActions("oidcStore", [
                "authenticateOidc",
                "authenticateOidcSilent"
            ]),
            userLoaded: function () {
                let that = this;
                setTimeout(function () {
                    if (that.$store.getters.oidcIdToken == null) {
                        that.authenticateOidc();
                    }
                }, 100);
            },
            oidcError: function (e) {
                console.log('I am listening to the oidc error event in vuex-oidc', e);
                this.authenticateOidc();
            },
            callOnce: function () {
                this.authenticateOidcSilent();
                let that = this;
                setTimeout(function () {
                    that.isSilentLoginOnceCalled = true;
                }, 1000);
            }
        },
        mounted() {
            this.$store.dispatch("oidcStore/getOidcUser");
            service.GetEnviromentVariables().then(() => {
                let that = this;
                window.addEventListener('vuexoidc:userLoaded', this.userLoaded);
                window.addEventListener('vuexoidc:oidcError', this.oidcError);
                setInterval(function () {
                    if (that.$store.getters.isFirstLoadCompleted)
                        that.$store.dispatch("triggerSilentLogin");
                }, 210000);
            });
            this.callOnce();
        },
        unmounted() {
            window.removeEventListener('vuexoidc:userLoaded', this.userLoaded)
            window.removeEventListener('vuexoidc:oidcError', this.oidcError)
        }
    };
</script>

<style>
    body {
        font-family: "Franklin Gothic Medium", "Arial Narrow", Arial, sans-serif;
        margin: 0;
        overflow: hidden;
    }
</style>
